import { tv } from 'tailwind-variants'

import { typography } from '@gto/ui/typography'

export const linkVariants = tv({
  slots: {
    root: [
      'inline-flex max-w-fit items-center gap-1',
      typography.body2,
      'cursor-pointer transition-[color,text-decoration-color,box-shadow,border-color] duration-150',
      'focus-visible:outline-none',
    ],
    icon: 'inline-block size-[1em] shrink-0 text-[inherit]',
  },
  variants: {
    underline: {
      always: {
        root: [
          'text-text-primary underline decoration-text-primary [text-decoration-thickness:1px] [text-underline-offset:25%]',
          'hover:text-primary-main hover:decoration-primary-main',
          'focus-visible:text-primary-main focus-visible:decoration-primary-main',
        ],
      },
      onHover: {
        root: [
          'text-primary-main no-underline',
          'hover:underline hover:decoration-primary-main hover:[text-decoration-thickness:1px] hover:[text-underline-offset:25%]',
          'focus-visible:underline focus-visible:decoration-primary-main focus-visible:[text-decoration-thickness:1px] focus-visible:[text-underline-offset:25%]',
        ],
      },
      none: {
        root: [
          'text-text-secondary no-underline',
          'hover:text-primary-main',
          'focus-visible:text-primary-main',
          'focus-visible:rounded-xs focus-visible:ring-2 focus-visible:ring-primary-main focus-visible:ring-offset-1',
        ],
      },
    },
    disabled: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      disabled: true,
      underline: 'always',
      className: {
        root: [
          'pointer-events-none cursor-default text-text-disabled [&_svg]:text-text-disabled',
          'underline decoration-text-disabled [text-decoration-thickness:1px] [text-underline-offset:25%]',
        ],
      },
    },
    {
      disabled: true,
      underline: 'onHover',
      className: {
        root: [
          'pointer-events-none cursor-default text-text-disabled [&_svg]:text-text-disabled',
          'no-underline',
        ],
      },
    },
    {
      disabled: true,
      underline: 'none',
      className: {
        root: [
          'pointer-events-none cursor-default text-text-disabled [&_svg]:text-text-disabled',
          'no-underline',
        ],
      },
    },
  ],
  defaultVariants: {
    underline: 'always',
    disabled: false,
  },
})

export type LinkVariants = Parameters<typeof linkVariants>[0]
